import React, { useEffect, useRef, useState } from "react";
import { Text } from "../../../../components/Text";
import { useDispatch, useSelector } from "react-redux";
import modulesName from "../../../../roles/modulesName";
import permissions from "../../../../roles/permissions";
import { API_GET_ALL_AGENTS } from "../../../../api/account.service";
import { Dropdown } from "primereact/dropdown";
import { Divider } from "primereact/divider";
import { CustomButton } from "../../../../components/CustomButton";
import { Tooltip } from "primereact/tooltip";
import CustomSaveModel from "../../../../components/CustomeSaveModel";
import CONSTANTS from "../../../../config/Constants";
import { deleteAgentMessage } from "../../../../reducers/chatSettingSlice";
import { Toast } from "primereact/toast";

const AgentChat = () => {
  const { accesskey } = useSelector((state) => state.authenticate);
  // const { toast, setLoading } = useLayout(null);

  const [selectedAgent, setSelectedAgent] = useState("");
  const [allAgents, setAllAgents] = useState([]);
  const [showSave, setShowSave] = useState(false);
  const dispatch = useDispatch();
  const toast = useRef(null);

  const SaveModel = () => {
    return (
      <CustomSaveModel
        showSave={showSave}
        header={alertText()}
        dialogFooter={dialogFooter}
        onHide={onHide}
      />
    );
  };
  const alertText = () => {
    return <div>{CONSTANTS.DELETE_AGENTS_CHAT}</div>;
  };
  const dialogFooter = () => {
    return (
      <div className="flex justify-content-end ">
        <CustomButton
          label="Cancel"
          varient="cancel"
          autofocus={true}
          onClick={() => {
            setShowSave(false);
          }}
        />
        <CustomButton
          label="Confirm"
          varient="filled"
          onClick={DeleteAgentChat}
        />
      </div>
    );
  };
  const onHide = () => {
    setShowSave(false);
  };

  useEffect(() => {
    if (accesskey[modulesName.SALES]?.includes(permissions.CREATE)) {
      API_GET_ALL_AGENTS()
        .then((data) => {
          let supportAgents = data.user.rows.map((agent) => {
            return { value: agent?.id, label: agent?.userName };
          });
          setAllAgents(supportAgents);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    }
  }, []);

  const DeleteAgentChat = () => {
    let payloadData = {
      // startDate:  ,
      // endDate: "",
      agentId: selectedAgent,
    };
    dispatch(deleteAgentMessage(payloadData))
      ?.unwrap()
      ?.then((res) => {
        toast.current.show({
          severity: "success",
          detail: `All Firebase messages deleted successfully.`,
          life: 3000,
        });
        onHide()
        setSelectedAgent('')
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          detail: err?.error || err?.message,
          life: 3000,
        });
      });
  };
  return (
    <div>
      <Toast ref={toast} />
      <SaveModel />
      <div className="flex items-center gap-2">
        <Text type={"heading"}>Delete Agent Chat</Text>
        <i
          className="pi pi-info-circle text-gray-500"
          data-pr-tooltip="This action will permanently delete all chat histories associated with the selected agent."
        ></i>
      </div>
      <Tooltip target=".pi-info-circle" />

      <Divider />
      <div className="field mt-3 col-3">
        <label htmlFor="otherFilter">Select an Agent to Delete Chats</label>
        <Dropdown
          id="otherFilter"
          value={selectedAgent}
          options={allAgents}
          onChange={(e) => setSelectedAgent(e.value)}
          placeholder="Select an Option"
          className="w-full"
        />
      </div>
      <div className="mx-2">
        <CustomButton
          label={"Delete Chats"}
          // icon={"pi p"}
          disabled={selectedAgent ? false : true}
          onClick={() => setShowSave(true)}
        />
      </div>
    </div>
  );
};

export default AgentChat;
